import React from 'react';

import styles from './WidgetLoader.less';

export const WidgetLoader: React.FC = () => {
    return (
        <div className={styles.loader__bg}>
            <aside className={styles.loader}>
                <div className={styles.header}>
                    <div className={styles.header__circle}></div>
                    <div className={styles.header__heading}>
                        <div className={styles.header__heading__title}>ВТБ</div>
                        <div className={styles.header__heading__subtitle}>
                            Устанавливаем соединение...
                        </div>
                    </div>
                    <div className={styles.header__expand_btn}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="20"
                            viewBox="0 0 21 20"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M14.1038 8.3232C13.9475 8.47939 13.6943 8.47937 13.5381 8.32316L12.6896 7.47462C12.5334 7.31839 12.5334 7.06511 12.6896 6.90891L16.7506 2.84884L15.243 1.34123C14.748 0.846283 15.0986 0 15.7985 0H20.1871C20.621 0 20.9728 0.351758 20.9728 0.785674V5.17428C20.9728 5.87425 20.1265 6.22479 19.6316 5.72984L18.1648 4.26305L14.1038 8.3232ZM7.85241 11.6648C8.00864 11.5087 8.26182 11.5088 8.41799 11.665L9.26649 12.5135C9.42274 12.6698 9.42268 12.9231 9.26637 13.0793L5.19879 17.1436L6.7064 18.6512C7.20134 19.1461 6.8508 19.9924 6.15084 19.9924H1.76224C1.32832 19.9924 0.976562 19.6407 0.976562 19.2068V14.8181C0.976562 14.1182 1.82285 13.7676 2.31779 14.2626L3.78458 15.7294L7.85241 11.6648Z"
                                fill="#0663EF"
                            />
                        </svg>
                    </div>
                </div>
                <div className={styles.header_mobile}>
                    <div className={styles.header_mobile__back_btn}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M13.2029 0.221803C13.3552 0.0618265 13.6084 0.0556443 13.7684 0.207994L14.6374 1.03556C14.7973 1.18791 14.8035 1.4411 14.6512 1.60107L6.6988 9.95152L14.8904 18.3882C15.0443 18.5467 15.0406 18.7999 14.8821 18.9538L14.0211 19.7897C13.8626 19.9436 13.6094 19.9399 13.4555 19.7814L4.19212 10.2409C4.04247 10.0868 4.04129 9.84197 4.18944 9.6864L13.2029 0.221803Z"
                                fill="#0663EF"
                            />
                        </svg>
                    </div>
                    <div className={styles.header_mobile__heading}>
                        <div className={styles.header_mobile__heading_title}>ВТБ</div>
                        <div className={styles.header_mobile__heading_subtitle}>
                            Устанавливаем соединение...
                        </div>
                    </div>
                    <div className={styles.header_mobile__circle_container}>
                        <div className={styles.header_mobile__circle}></div>
                    </div>
                </div>
                <div className={styles.content}>
                    <div className={styles.content__loader}>
                        <div className={styles.content__loader_line}></div>
                    </div>
                </div>
                <div className={styles.footer}>
                    <div className={styles.hovering_buttons}>
                        {[0, 0, 0].map((e, i) => {
                            return <div key={i} className={styles.hovering_buttons__button}></div>;
                        })}
                    </div>
                    <div className={styles.inputpanel}>
                        <div className={styles.inputpanel__circle}></div>
                        <div className={styles.inputpanel__input}></div>
                        <div className={styles.inputpanel__circle}></div>
                    </div>
                </div>
            </aside>
        </div>
    );
};
